import { render } from "./App.vue?vue&type=template&id=3597d136"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3597d136&lang=css"
script.render = render

export default script